/* =============================================================
   L'a.t.lier — Thème Shopify custom · JS
   Aucune dépendance externe.
   ============================================================= */
(function () {
  'use strict';

  var money = window.LATELIER_MONEY_FORMAT || '{{amount_with_comma_separator}} €';

  function formatMoney(cents) {
    var value = (cents / 100);
    if (money.indexOf('amount_no_decimals') > -1) {
      return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/,
        Math.round(value).toLocaleString('fr-FR'));
    }
    var formatted = value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted)
                .replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  /* ----------------------------------------------------------
     1. Révélation au défilement
     ---------------------------------------------------------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.fade-in-up:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------
     2. En-tête compact au scroll
     ---------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ----------------------------------------------------------
     3. Menu plein écran
     ---------------------------------------------------------- */
  function initNav() {
    var drawer = document.querySelector('[data-navdrawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-nav-open]');
    var closers = drawer.querySelectorAll('[data-nav-close]');

    function open() {
      drawer.classList.add('is-open');
      document.body.classList.add('is-locked');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ----------------------------------------------------------
     4. Écran d'entrée (page d'accueil)
     ---------------------------------------------------------- */
  function initLanding() {
    var landing = document.querySelector('[data-landing]');
    if (!landing) return;
    var key = 'latelier:entered';
    var alreadyEntered = false;
    try { alreadyEntered = sessionStorage.getItem(key) === '1'; } catch (e) {}

    if (alreadyEntered) {
      landing.remove();
      document.body.classList.remove('is-locked');
      return;
    }
    document.body.classList.add('is-locked');
    var btn = landing.querySelector('[data-landing-enter]');
    if (btn) {
      btn.addEventListener('click', function () {
        landing.style.transition = 'opacity .6s ease';
        landing.style.opacity = '0';
        document.body.classList.remove('is-locked');
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        setTimeout(function () { landing.remove(); initReveal(); }, 600);
      });
    }
  }

  /* ----------------------------------------------------------
     5. Carrousel Instagram
     ---------------------------------------------------------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      root.querySelectorAll('[data-carousel-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-carousel-nav') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * (track.offsetWidth / 2), behavior: 'smooth' });
        });
      });
    });
  }

  /* ----------------------------------------------------------
     6. Sélecteurs de quantité
     ---------------------------------------------------------- */
  function initQty(scope) {
    (scope || document).querySelectorAll('[data-qty]').forEach(function (widget) {
      if (widget.dataset.qtyBound) return;
      widget.dataset.qtyBound = '1';
      var input = widget.querySelector('[data-qty-input]');
      widget.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ----------------------------------------------------------
     7. Panier AJAX
     ---------------------------------------------------------- */
  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      Cart.drawer = document.querySelector('[data-cart-drawer]');
      Cart.overlay = document.querySelector('[data-cart-overlay]');
      if (!Cart.drawer) return;

      document.querySelectorAll('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
      });
      [].concat(
        Array.prototype.slice.call(Cart.drawer.querySelectorAll('[data-cart-close]')),
        Cart.overlay ? [Cart.overlay] : []
      ).forEach(function (b) { b.addEventListener('click', Cart.close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Cart.close();
      });

      Cart.drawer.addEventListener('click', Cart.onDrawerClick);
      Cart.drawer.addEventListener('change', Cart.onDrawerChange);
    },

    open: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.add('is-open');
      if (Cart.overlay) Cart.overlay.classList.add('is-open');
      document.body.classList.add('is-locked');
    },

    close: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.remove('is-open');
      if (Cart.overlay) Cart.overlay.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    },

    onDrawerClick: function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        Cart.change(remove.getAttribute('data-cart-remove'), 0);
      }
    },

    onDrawerChange: function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) {
        Cart.change(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0);
      }
    },

    change: function (key, quantity) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); })
        .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; });
    },

    add: function (formData, button) {
      var original = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Ajout en cours…'; }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message);
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          Cart.render(cart);
          Cart.open();
        })
        .catch(function (err) {
          var box = document.querySelector('[data-product-error]');
          if (box) { box.textContent = err.message; box.hidden = false; }
          else { alert(err.message); }
        })
        .finally(function () {
          if (button) { button.disabled = false; button.textContent = original; }
        });
    },

    render: function (cart) {
      // Compteur
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-count-text]').forEach(function (el) {
        el.textContent = 'Panier (' + cart.item_count + ')';
      });

      var body = Cart.drawer && Cart.drawer.querySelector('[data-cart-body]');
      var foot = Cart.drawer && Cart.drawer.querySelector('[data-cart-foot]');
      if (!body) return;

      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty">' +
          '<p class="lead">Votre panier est vide.</p>' +
          '<a class="link-underline" href="' + window.Shopify.routes.root + 'collections/all">Découvrir la boutique</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }

      if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_240x$1') + '" alt="' + item.product_title + '" loading="lazy">'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
        return '' +
          '<div class="cart-line">' +
            '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
            '<div class="cart-line__info">' +
              '<a href="' + item.url + '"><h3 class="cart-line__title">' + item.product_title + '</h3></a>' +
              variant +
              '<div class="qty" data-qty>' +
                '<button class="qty__btn" type="button" data-qty-step="-1" aria-label="Diminuer">&minus;</button>' +
                '<input class="qty__input" type="number" min="0" value="' + item.quantity + '" data-qty-input data-cart-qty="' + item.key + '" aria-label="Quantité">' +
                '<button class="qty__btn" type="button" data-qty-step="1" aria-label="Augmenter">+</button>' +
              '</div>' +
              '<div class="cart-line__bottom">' +
                '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
                '<button class="cart-line__remove" type="button" data-cart-remove="' + item.key + '">Retirer</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      var total = Cart.drawer.querySelector('[data-cart-total]');
      if (total) total.textContent = formatMoney(cart.total_price);

      initQty(body);
    }
  };

  /* ----------------------------------------------------------
     8. Formulaire produit
     ---------------------------------------------------------- */
  function initProductForm() {
    document.querySelectorAll('[data-product-form], form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var box = form.querySelector('[data-product-error]');
        if (box) box.hidden = true;
        Cart.add(new FormData(form), form.querySelector('[data-add-to-cart]'));
      });
    });

    // Sélecteur de variante
    document.querySelectorAll('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var priceEl = document.querySelector('[data-variant-price]');
        var btn = document.querySelector('[data-add-to-cart]');
        var idInput = document.querySelector('[data-variant-id]');
        if (idInput) idInput.value = select.value;
        if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
        if (btn) {
          var available = opt.dataset.available === 'true';
          btn.disabled = !available;
          btn.textContent = available ? 'Ajouter au panier' : 'Épuisé';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ----------------------------------------------------------
     9. Galerie produit
     ---------------------------------------------------------- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]') || document.getElementById('PdpMainImage');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-gallery-thumb');
        main.srcset = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----------------------------------------------------------
     Boot
     ---------------------------------------------------------- */
  function boot() {
    initLanding();
    initHeader();
    initNav();
    initReveal();
    initCarousels();
    initQty();
    Cart.init();
    initProductForm();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initQty(e.target);
    initCarousels();
    initHeader();
    initNav();
    Cart.init();
    initProductForm();
    initGallery();
  });

  window.LatelierCart = Cart;
})();
